// Using double quotes in this file to prevent issues with apostrophes (')
export default {
  header: {
    ai: {
      title: 'Pregunta a HP Nio',
      close: 'Cerrar chat de Nio',
      open: 'Abrir el chat de Nio',
      morningGreeting: "Buenos días, {0}:",
      afternoonGreeting: "Buenas tardes, {0}:",
      eveningGreeting: "Buenas noches, {0}:",
      morningGreetingGeneric: "Buenos días:",
      afternoonGreetingGeneric: "Buenas tardes:",
      eveningGreetingGeneric: "Buenas noches:",
      opening: "Soy Nio. ¿Cómo puedo ayudar?",
      openingPrivacy: "Soy Nio.",
      pbIntro1: "Pregúnteme sobre la productividad de su dispositivo.",
      alertBeta: "Nio está en fase beta temprana.  Las respuestas se limitan actualmente a Print Beat y Zona de conocimiento.",
      alertDefault: "Las respuestas se limitan actualmente a Print Beat y Zona de conocimiento.",
      intro2:  "Aquí hay algunas preguntas que podrían interesarle:",
      kzIntro1: "Pregúnteme sus inquietudes y le responderé con información de la Zona del Conocimiento.",
      pbSample1: "¿Qué tan productivo fue el sitio ayer?",
      pbSample2: "¿Cómo puedo mejorar mi productividad?",
      pbSample3: "¿Qué imprenta supera al resto de mis imprentas?",
      pbSample4: "¿Qué sustrato me causó la mayor cantidad de tiempo perdido?",
      pbSample5: "¿En qué problema perdí más tiempo la semana pasada?",
      kzSample1: "¿Cómo puedo reducir el desperdicio de sustratos mientras mantengo la calidad y reduzco costes?",
      kzSample2: "¿Qué imprenta HP Indigo es mejor en lo que respecta a la impresión eficiente de etiquetas de vino con consistencia de color?",
      kzSample3: "¿Cómo puedo optimizar el uso de consumibles para mejorar la productividad?",
      kzSample4: "¿Cuál de los factores de sostenibilidad clave debería considerar al imprimir?",
      kzSample5: "¿Cómo garantizo la consistencia de color entre mis imprentas HP Indigo 6000 y 20K?",
      feedbackTitle: "Motivo de su puntuación",
      feedbackPlaceholder: "¿Puede explicar lo sucedido con detalle?",
      fbPositive1: "Los datos son correctos",
      fbPositive2: "Muy buena respuesta",
      fbPositive3: "Muy detallada",
      fbPositive4: "La respuesta fue relevante",
      fbOther: "Otro",
      fbNegative1: "La información o los datos son incorrectos",
      fbNegative2: "Las respuesta no aclaró mi pregunta",
      fbNegative3: "La respuesta fue confusa o poco clara",
      fbNegative4: "La respuesta no fue relevante",
      feedbackSubmittedTitle: "¡Gracias por su retorno!",
      feedbackSubmittedDescription_Positive: "Nos alegra saber que la respuesta le resultó útil. Sus comentarios nos motivan a seguir ofreciendo mejores experiencias.",
      feedbackSubmittedDescription_Negative: "Le pedimos disculpas por las molestias que esto pueda haberle causado. Nuestro equipo revisará la información y trabajará para corregirla. Si tiene más información sobre el error o algún comentario adicional, háganoslo saber para ayudarnos a mejorar.",
      ask_Placeholder: "¿Qué desea saber?",
      answerCopiedToClipboard: "Respuesta copiada al portapapeles",
      feedbackSubmitted: "Comentarios enviados",
      feedbackCleared: "Comentarios eliminados",
      newConversation: "Nuevo chat",
      chatHistory: "Historial de chat",
      submitQuestion: "Enviar pregunta",
      defaultStopMessage: "Respuesta cancelada por el usuario.",
      stopQuestion: "Dejar de generar",
      responseError: "Vaya, parece que hemos encontrado un problema. Inténtalo de nuevo más tarde. Si el problema persiste, contacta con el servicio de asistencia.",
      responseError400: "Parece que su pregunta contiene caracteres inesperados. Quítelos para continuar.",
      responseError429: "Vaya, más despacio. No puedo seguir con tantas preguntas.",
      like: "Me gusta",
      dislike: "No me gusta",
      copy: "Copiar en portapapeles",
      retry: " Reintentar",
      contact: "Contacto",
      contactSubject: "Problema de HP Nio",
      contactQuestion: "Pregunta: {0}",
      noConversations: "No tiene conversaciones",
      startConversation: "Inicie una conversación para ver su historial de chat aquí",
      today: "Hoy",
      yesterday: "Ayer",
      lastWeek: "Última semana",
      older: "Más antiguo",
      chatDeletePolicy: "Los chats inactivos se eliminan a los 90 días.",
      privacyNotice: "Está interactuando con una solución de IA. Revise las respuestas, ya que podrían estar incompletas o ser inexactas.",
      privacy1: "Está a punto de participar en una solución de IA. Los chats pueden revisarse y utilizarse para entrenar nuestros modelos.",
      privacy2: `If you prefer to receive support in another way, please visit {0}.`,
      acceptPrivacy: "Empiezar a hablar con HP Nio",
      deleteConversationTitle: "Eliminar chat",
      conversationName: "Conversación",
      deleteConversationConfirm: "Esto eliminará <b>{0}</b>.<br>Esta acción no se puede deshacer.",
      deleteConversationSuccess: "Conversación eliminada",
      deleteConversationError: "No se pudo eliminar la conversación",
      renameConversationTitle: "Modificar nombre de la conversación",
      renameConversationMessage: "Nombre de la conversación",
      renameConversationSuccess: "Nombre de la conversación modificado",
      renameConversationError: "No se pudo modificar el nombre de la conversación",
      deleteConversation: "Suprimir",
      renameConversation: "Cambiar nombre",
    },
    apps: {
      title: "Menú",
      externalLinks: "Externo",
      availableApps: "Explorar",
      configure: "Personalizar",
      showApp: "Mostrar",
      hideApp: "Ocultar",
      setDefault: "Establecer aplicación predeterminada",
      setShortcut: "Establecer como anclado	",
      removeShortcut: "Desanclar",
      showAllApps: "Mostrar todas las aplicaciones",
      shortCutTooltip: "Ir a {0}",
      currentAccount: "Organización actual",
      goHome: "Ir a Inicio",
      goAppHome: "Ir a la página de inicio de la aplicación",
      byProvider: "en {0}",
      quickFilter: "Buscar aplicación...",
      allApps: "Todas las aplicaciones",
      recentApps: "Recientes",
      externalApp: "Aplicación externa a PrintOS",
      modeSwitcher: "Modo claro/oscuro",
      goProducts: "Explorar más aplicaciones"
    },
    panels: {
      ai: "Pregunta a HP Nio",
      notifications: "Mis notificaciones",
      help: "Ayuda y soporte",
      user: "Usuario",
      close: "Cerrar panel",
      moveLeft: "Mover a la izquierda",
      moveRight: "Mover a la derecha",
      maximize: "Maximizar",
      restore: "Restaurar",
    },
    user: {
      account: "Organización",
      returnToHP: "Devolver a HP Inc.",
      myOrganization: "Mi organización",
      myOrganizations: "Mis organizaciones",
      myReports: "Mis informes",
      mySettings: "Mi configuración",
      signOut: "Cerrar sesión",
      signInExplanation: "Inicie sesión en HP PrintOS para ver sus notificaciones y aplicaciones.",
      signIn: "Iniciar sesión",
      RCDA: "Acceso de cliente",
      orphanUser: "Usuario de PrintOS",
      orphanContext: "Sin organizaciones",
      deviceUser: "Dispositivo PrintOS",
      anonymous: "Usuario anónimo",
      name: "Nombre",
      email: "Correo electrónico",
      address: "Dirección",
      editUser: "Editar cuenta HP",
      viewPrivacy: "Ver Declaración de Privacidad"
    },
    date: {
      fewSecondsAgo: "Hace unos segundos",
      minuteAgo: "Hace un minuto",
      minutesAgo: "Hace {0} minutos",
      hourAgo: "Hace una hora",
      hoursAgo: "Hace {0} horas",
      dayAgo: "Hace un día",
      daysAgo: "Hace {0} días",
      monthAgo: "Hace un mes",
      monthsAgo: "Hace {0} meses",
      yearAgo: "Hace un año",
      yearsAgo: "Hace {0} años",
    },
    help: {
      quickFilter: "Buscar",
      page: "Página",
      app: "Aplicación",
      newFeatures: "Nuevas características",
      more: "Todo",
      contactHP: "Contactar con HP",
      noTopics: "No coincide ningún tema de ayuda",
      about: "Acerca de",
      terms: "Condiciones del servicio",
      readFile: "Documento",
      stepByStepTutorial: "Tutorial",
      goLink: "Página de aplicación",
      viewVideo: "Vídeo",
      goToUrl: "Vínculo",
      other: "Otro",
      faq: "Preguntas más frecuentes",
      new: "Nuevo tema",
      whatsNew: "Novedades",
      technicalSupport: "Asistencia de PrintOS",
      printOSFeedback: "Comentarios sobre PrintOS",
      conversationsWithHP: "Conversaciones con HP",
      youMayConsider: "Puede que le interese…",
      myKzArticles: "Mis artículos de Zona de conocimiento",
      kzServiceTopics: "{0} ({1})",
      lkcArticles: "Artículos del Centro de conocimiento de HP Latex",
    },
    notifications: {
      noNotifications: "No hay notificaciones",
      viewAll: "Ver todo",
      dismiss: "Descartar",
      dismissAll: "Descartar todo",
      subscriptions: "Configuración",
    },
    marketplace: {
      title: "Catálogo",
      explore: "Explorar todo",
      featured: "Destacadas",
      slides: {
        default: {
          description: "Mejore PrintOS con aplicaciones, extensiones y conectores premium"
        },
        oee: {
          title: "OEE de Print Beat",
          description: "Impulsar la excelencia operativa con información obtenida a partir de datos casi en tiempo real",
        },
      },
      partialProductivitySubscribePreEnforcement_Title: "A partir del 4 de agosto, el acceso a Print Beat, Jobs, OEE y servicios de Print Beat requerirá una <a href='https:/intercom.help/hp-printos/en/articles/11113950-hp-printos-productivity-power-pack' target='_blank'>suscripción al paquete de potenciamiento de productividad</a>.",
      partialProductivitySubscribePreEnforcement_Desc: "Los datos de los dispositivos que cancelaron la suscripción se pueden extraer antes de agosto.",
      partialProductivitySubscribePostEnforcement_Title: "No todos sus dispositivos Indigo están suscritos al Paquete de potenciamiento de productividad ({0}/{1})",
      partialProductivitySubscribePostEnforcement_Desc: "Los dispositivos no suscritos pueden limitar su experiencia con PrintOS (Print Beat, Jobs, OEE, Paneles de control, etc.)",
      goToMarket_Action: "Ir al catálogo",
      howToExtract_Action: "Cómo extraigo mis datos"
    },
    focus: {
      title: "Foco",
    },
    locales: {
      "de-DE": "Alemán",
      "en-GB": "Inglés (Reino Unido)",
      "en-US": "Inglés (Estados Unidos)",
      "es-ES": "Español",
      "fr-FR": "Francés",
      "it-IT": "Italiano",
      "ja-JP": "Japonés",
      "ko-KO": "Coreano",
      "pt-PT": "Portugués",
      "tr-TR": "Turco",
      "zh-HANS": "Chino (simplificado)",
      "ru-RU": "Ruso",
      "Traducción parcial": "Traducciones parciales",
    },
    modal: {
      ok: "Aceptar",
      cancel: "Cancelar",
    },
    combo: {
      noItems: "No se encontró ninguna coincidencia",
    },
    nps: {
      question: "Hola, {0}. ¿Con qué probabilidad le recomendaría PrintOS a un compañero de trabajo?",
      // In case we can't get user's display name
      questionNameless: "¿Con qué probabilidad le recomendaría PrintOS a un compañero de trabajo?",
      notLikely: "Muy poco probable",
      likely: "Mucha",
      send: "Enviar comentarios",
      response: {
        detractor: "{0}, ¿qué podemos hacer para mejorar su experiencia con PrintOS? Leemos todos los comentarios.",
        detractorNameless: "¿Qué podemos hacer para mejorar su experiencia con PrintOS? Leemos todos los comentarios.",
        passive: "{0}, indíquenos cómo podemos hacer que su experiencia de PrintOS sea incluso mejor. Leemos todos los comentarios.",
        passiveNameless: "Indíquenos cómo podemos hacer que su experiencia de PrintOS sea incluso mejor. Leemos todos los comentarios.",
        promoter: "{0}, estamos encantados de que disfrute al usar PrintOS. Díganos por qué. Leemos todos los comentarios.",
        promoterNameless: "Estamos encantados de que disfrute al usar PrintOS. Díganos por qué. Leemos todos los comentarios.",
      },
      introMorning: "Buenos días, {0}. Soy Jon, el gestor de éxito del cliente para PrintOS.",
      introMorningNameless: "Buenos días. Soy Jon, el gestor de éxito del cliente para PrintOS.",
      introAfternoon: "Buenas tardes, {0}. Soy Jon, el gestor de éxito del cliente para PrintOS.",
      introAfternoonNameless: "Buenas tardes. Soy Jon, el gestor de éxito del cliente para PrintOS.",
      introEvening: "Buenas noches, {0}. Soy Jon, el gestor de éxito del cliente para PrintOS.",
      introEveningNameless: "Buenas noches. Soy Jon, el gestor de éxito del cliente para PrintOS.",
      intro2: "Por favor, responda a la siguiente pregunta para ayudarme a entender su experiencia de PrintOS:",
      intro3: "¿Con qué probabilidad le recomendaría PrintOS a un compañero de trabajo?",
      detractorResponse: "¡Gracias por su respuesta, {0}!  Apreciamos tanto los comentarios positivos como los críticos.",
      detractorResponseNameless: "Gracias por su respuesta,  Apreciamos tanto los comentarios positivos como los críticos.",
      promoterResponse: "¡Gracias, {0}! Nos encanta saber que usted es fan de PrintOS. Sus comentarios todavía nos pueden ayudar a ofrecer la mejor experiencia posible.",
      promoterResponseNameless: "¡Gracias!  Nos encanta saber que usted es fan de PrintOS. Sus comentarios todavía nos pueden ayudar a ofrecer la mejor experiencia posible.",
      response2: "Elija una aplicación e indíquenos cómo podemos mejorar su experiencia de PrintOS.",
      response3: "El equipo de satisfacción del cliente revisa todos los comentarios.  Puede que nos pongamos en contacto con usted para entender mejor su opinión.",
      feedbackPlaceholder: "PrintOS puede mejorarse...",
      application: "Aplicación",
      noApplication: "PrintOS - Comentarios generales"
    },
    subscription: {
      title: "Suscripción",
      subscribe: "¡Subscríbase ahora!",
      noticeSingular: "Su suscripción de {0} caduca en {1} día.",
      notice: "Su suscripción de {0} caduca en {1} días.",
    },
    promotion: {
      label: "Promoción",
      title: "Aviso de período promocional",
      notice: "Está en un período promocional para esta aplicación.",
    },
    trial: {
      label: "La versión de prueba caduca en breve",
      title: "Periodo de prueba",
      noticeSingular: "{0} se encuentra en un período de prueba. La prueba caduca en {1} día.",
      notice: "{0} se encuentra en un período de prueba. La prueba caduca en {1} días.",
    },
    subscriptionExpired: {
      label: "Suscripción caducada",
      title: "Suscripción caducada",
      notice: "Suscripción de {0} ha caducado. Después de un breve período de gracia, ya no podrá obtener acceso a esta función.",
    },
    trialExpired: {
      label: "Prueba caducada",
      title: "Periodo de prueba caducado",
      notice: "Su período de prueba de {0} ha caducado. Después de un breve período de gracia, ya no podrá obtener acceso a esta función.",
    },
    hpWarning: "{0}\nEs un representante de HP Inc. en una organización de cliente. Tenga cuidado.",
    role: {
      HP_Operation: "Operación de HP",
      HP_Sales_and_Marketing: "Trato directo con el cliente HP",
      SystemRoleGenesis_Admin: "Admi de servicio PrintOS",
      SystemRoleGenesis_Support: "Admi de HP Inc.",
      SystemRoleGenesis_R_AND_D: "I+D de Genesis",
      CE_Level_1: "CE nivel 1",
      CE_Level_2: "CE nivel 2",
      Application_Engineer: "Ingeniero de aplicación",
      Ramp_Up_Engineer: "Técnico de puesta a punto",
      Support_Engineer: "Técnico de asistencia",
      Remote_Support_Engineer: "Técnico de soporte HP",
      Specialist: "Especialista",
      Certification_Centers: "Centros de certificación",
      Supplies_and_Media_Personnel: "Personal de suministros y sustratos",
      Supplies_and_Media_Admin: "Administrador de suministros y sustratos",
      HP_Service: "Servicio HP",
      HP_Training: "Formación HP",
      Admin: "Administrador",
      Pre_Press_Operator: "Usuario",
      Press_Operator: "Operador",
      Dashboard: "Panel",
      Channel_Sales_and_Marketing: "Marketing y ventas de canal",
      Channel_Operation: "Operación de canal",
      Channel_CE_Level_1: "Técnico de distribución Nivel 1",
      Channel_CE_Level_2: "Técnico de distribución Nivel 2",
      HP_Read_Only: "HP Solo Lectura",
      Reseller_Manager: "Gestor de vendedores finales",
      Business_Partner_Manager: "Gestor de socios comerciales",
      Call_Center: "Centro de llamadas",
      Field_Engineer: "Ingeniero de campo",
      ThreeD_Business_Manager: "3D Business Manager",
      HPInPsp: "HP en PSP",
      ChannelInPsp: "Canal en PSP",
      GenericAdmin: "Administrador",
      GenericUser1: "Nivel de usuario 1",
      GenericUser2: "Nivel de usuario 2",
      Generic_Read_Only: "Solo lectura",
      ThreeD_Care_Center: "Centro de atención 3D",
      ThreeD_Cost_Calculator: "Costes de 3D",
      Composer_External: "Acceso limitado: Composer",
      SIM_External: "Acceso limitado: administrador de inventario de consumibles",
      Multiple: "Varios roles"
    },
    inlineAlerts: {
      Http_429_Error: "Tráfico alto",
      Http_429_Description: "El servicio está experimentando cargas anormales en este momento.  Algunas funciones pueden no estar disponibles temporalmente.  Actualice la página para volver a intentarlo",
      Http_429_Action: "Refrescar",
      NewSubscription: "Nueva suscripción: {0}",
      NewSubscriptionDescription: "Su organización tiene una nueva suscripción",
      NewSubscriptionAction: "Más información",
      SubscriptionExpired: "Suscripción caducada: {0}",
      SubscriptionExpiredDescription: "Su suscripción caducó el {0}",
      SubscriptionExpiredAction: "Ver suscripción",
      Subscription30DayWarning: "La suscripción caducará: {0}",
      Subscription30DayWarningDescription: "Su suscripción caducará en {0} días el {1}",
      Subscription30DayWarningAction: "Ver suscripción",
      Subscription15DayWarning: "La suscripción caduca pronto: {0}",
      Subscription15DayWarningDescription: "Su suscripción caducará en {0} días el {1}",
      Subscription15DayWarningAction: "Ver suscripción",
      JoinOrgRequestAccepted: "Solicitud para unirse a la organización aceptada",
      JoinOrgRequestAcceptedDescription: "Se le otorgó acceso para <b>{0}</b>",
      JoinOrgRequestSwitch: "Abrir organización",
      JoinOrgRequestDenied: "Solicitud para unirse a la organización denegada",
      JoinOrgRequestDeniedDescription: "El administrador denegó su solicitud para unirse a <b>{0}</b>",
      NonHPContext: "Abrir ventana contextual ajena a hp",
      NonHPContextDescription: "Contexto: {0}",
      CloseContext: "Cerrar Contexto"
    },
    ui: {
      Confirm: "Confirmar",
      Notify: "Notificación",
      OpenImage: "Abrir archivo de imagen",
      Dismiss: "Descartar",
      CheckingContext: "Verificando contexto...",
      LoadingContext: "Restaurando {0}..."
    }
  }
};
